import { combineReducers } from "@reduxjs/toolkit";
import itemsReducer from "../features/items/itemSlice";

const rootReducer = combineReducers({
  items: itemsReducer,
});

export default rootReducer;

